import { useLocation } from "react-router-dom";

interface SeoProps {
  title: string;
  description: string;
  keywords: string;
}

export default function Seo({ title, description, keywords }: SeoProps) {
  const { pathname } = useLocation();
  const base = __BASE_PATH__.replace(/\/$/, "");
  const canonical = `${window.location.origin}${base}${pathname}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
    </>
  );
}